import Animate from '../utils/animate';

export default class BrandSlider {
    constructor({el, options = {}}) {
        this.el = el;
        const railWidth = this.el.querySelector('.slide-rail').offsetWidth;

        setTimeout(() => {
            this.settings = {
                vw: railWidth,
                max: this.el.querySelector('.slide-rail ul').offsetWidth - railWidth,
                min: 0
            };
    
            this.canDoPrev = false;
            this.canDoNext = true;
    
            this.bind();
            this.current = 0;
        }, 500);
    }

    bind() {
        this.el.addEventListener('click', evt => {
            if (evt.target.classList.contains('next') || evt.target.classList.contains('prev')) {
                evt.preventDefault();
                const dir = evt.target.classList.contains('next') ? 1 : -1;

                if (dir === -1 && !this.canDoPrev) {
                    return;
                }

                if (dir === 1 && !this.canDoNext) {
                    return;
                }

                const rail = this.el.querySelector('.slide-rail');
                const list = rail.querySelector('ul');
                let from = this.current * this.settings.vw;

                if (from > this.settings.max) {
                    from = this.settings.max;
                }

                let diff = (dir * this.settings.vw);
                const dest = from + diff;

                if (dest > this.settings.max) {
                    diff = this.settings.max - from;
                    this.canDoNext = false;
                    this.canDoPrev = true;
                } else if (dest < this.settings.min) {
                    diff = -from;
                    this.canDoPrev = false;
                    this.canDoNext = true;
                } else {
                    this.canDoNext = true;
                    this.canDoPrev = true;
                }

                Animate(from, diff, {
                    duration: 500,
                    fn: 'easeOutQuad',
                    onStep: val => {

                        list.style.transform = `translate3d(${-val}px, 0, 0)`;
                    },
                    onFinish: () => {
                        this.current = this.current + dir;
                    }
                });
            }
        });
    }
}
